import React from 'react';
import Highcharts from 'highcharts/highstock';
import {
  Chart,
  ColumnSeries,
  HighchartsProvider,
  HighchartsStockChart,
  Legend,
  LineSeries,
  Title,
  Tooltip,
  XAxis,
  YAxis
} from 'react-jsx-highstock';
import {primaryColor} from '../../utils';
import {Box} from '@mui/material';

const plotOptions = {
  column: {
    // pointWidth: 6,
    // maxPointWidth: 50,
    minPointLength: 3, // By default, 0 values are not shown. To visualize a 0 (or close to zero) point, set the minimal point length to a pixel value like 3
    borderWidth: 0
  },
  series: {
    turboThreshold: 1000000,
    shadow: true,
    dataGrouping: {
      approximation: 'average',
      groupAll: true,
      groupPixelWidth: 20,
      //. An array determining what time intervals the ticks are allowed to fall on.
      // Each array item is an array where the first value is the time unit and
      // the second value another array of allowed multiples.
      // units: [
      //   [
      //     'millisecond', // unit name
      //     [] // allowed multiples
      //   ], [
      //     'second',
      //     []
      //   ], [
      //     'minute',
      //     [10]
      //   ], [
      //     'hour',
      //     [1, 4, 12]
      //   ], [
      //     'day',
      //     [1, 2]
      //   ], [
      //     'week',
      //     [1, 2]
      //   ], [
      //     'month',
      //     [1, 2, 3, 4, 6]
      //   ], [
      //     'year',
      //     null
      //   ]]
    }
  }
};

const plotHorizontalNoiseLines = [{
  zIndex: -1,
  value: 55,
  color: 'green',
  dashStyle: 'shortdash',
  width: 2
}, {
  zIndex: -1,
  value: 45,
  color: 'red',
  dashStyle: 'shortdash',
  width: 2
}];


const timeOptions = {
  useUTC: false
};

const options = {
  noData: {
    style: {
      fontWeight: 'bold',
      fontSize: '15px',
      color: '#303030'
    },
    useHTML: false
  }
};
const units = 'dBA';


export default function NoiseChart({title, seriesList, columns}) {
  // const [columns, setColumns] = useState(false);
  // const handleColumnsToggle = () => setColumns(!columns);

  return (<div>
      <HighchartsProvider Highcharts={Highcharts}>
        <Box position={'absolute'} right={40} top={5} zIndex={100} sx={{display: 'flex', gap: 2}}>
          <Box
            sx={{
              display: 'flex', position: 'relative', gap: 2,
              '@media screen and (max-width: 40em)': {top: '2em', right: '3.3em'}
            }}>
          </Box>
        </Box>
        <HighchartsStockChart options={options} plotOptions={plotOptions} time={timeOptions}>
          <Chart/>
          <Legend align={'left'} verticalAlign={'top'} x={40} y={30}/>
          <Tooltip shared={true} split={false} valueSuffix={' ' + units} valueDecimals={2} />
          <Title style={{color: primaryColor[2]}} align={'center'}>{title}</Title>
          <XAxis/>

          <YAxis
            min={0}
            max={100}
            // plotLines={plotHorizontalNoiseLines}
          >
            <YAxis.Title>{units}</YAxis.Title>

            {/*<ColumnSeries color="green" id="AeqD" name="<b>L<sub>AeqD</sub><b>" dashStyle="shortdash"/>*/}
            {/*<ColumnSeries color="red" id="AeqN" name="<b>L<sub>AeqN</sub></b>" dashStyle="shortdash"/>*/}
            {seriesList.filter(series => series.data.length > 0).map(series => {
              const id = series.name.replace(' ', '');
              if (columns) {
                return <ColumnSeries yAxis={0} key={id} id={id} name={series.name}
                                     data={series.data}/>;
              } else {
                //tooltip={{valueSuffix: ' ' + units}}
                return <LineSeries yAxis={0} key={id} id={id} name={series.name}
                                   data={series.data}/>;
              }
            })}



          </YAxis>
        </HighchartsStockChart>
      </HighchartsProvider>
    </div>
  );
}
